import * as angular from 'angular';

import { ReportsRepo as reportsRepo } from './reports.repo';
import { ClientRepo as clientsRepo } from '../clients/client.repo';
import {reports} from './reports';

export const reportsModule = 'reports'

angular
  .module(reportsModule, [])
  .service('clientsRepo', clientsRepo)
  .service('reportsRepo', reportsRepo)
  .component('reports', reports)



// WEBPACK FOOTER //
// ./src/app/reports/reports.index.ts